/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Seeall1Inputs */

const he_home_seeall1 = /** @type {(inputs: Home_Seeall1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכל`)
};

const en_home_seeall1 = /** @type {(inputs: Home_Seeall1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all`)
};

/**
* | output |
* | --- |
* | "See all" |
*
* @param {Home_Seeall1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const home_seeall1 = /** @type {((inputs?: Home_Seeall1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Seeall1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_seeall1(inputs)
	return en_home_seeall1(inputs)
});
export { home_seeall1 as "home_seeAll" }